import InAppRoutes from 'utils/router';
import { Helmet as ReactHelmet } from 'react-helmet';
import { useLocation, matchPath } from 'react-router-dom';
import { IS_RCI_DEPLOYMENT } from 'actions/utils';

const RouteData: { [key: string]: { title?: string; fullTitle?: string } } = {
  [InAppRoutes.Login]: { title: 'Login' },
  [InAppRoutes.Root]: { title: 'Gloo' },
};

function Helmet() {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = IS_RCI_DEPLOYMENT ? 'RCI' : 'Gloo';
  let title = prefix;

  Object.entries(RouteData).forEach(([path, data]) => {
    if (path) {
      const match = matchPath(pathname, { path, exact: true });
      if (match) {
        title = data.fullTitle || `${prefix} - ${data.title}`;
      }
    }
  });

  return <ReactHelmet title={title} />;
}

export default Helmet;
